const breadCrumbSteps = [
  "Transfer Details",
  "Personal Information",
  "Fund Selection",
  "Review & Sign"
];

export default breadCrumbSteps;
